/* angular:styles/component:scss;1b856f820c741ff21a53738e8c921ce86fdb68ad87914920300c87f9f9acdae3;D:\Techriff-Project\3amautocare\Autocare.Api\ClientApp\src\app\service-distributor\type\formly-selector-type.ts */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  color: #344054;
  padding: 8px;
}
::ng-deep .custom-dialog .p-dialog {
  border-radius: 16px !important;
  background: #FFF !important;
  color: #344054 !important;
  padding: 16px;
  width: 400px;
  position: relative;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}
::ng-deep .custom-dialog .p-dialog-header {
  display: none !important;
}
.panel-container {
  margin-bottom: 40px;
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #344054;
  margin-bottom: 20px;
  margin-top: 20px;
}
.remove-btn {
  background: red;
  color: white;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s ease-in-out;
}
.remove-btn:hover {
  background: darkred;
}
.panel-content {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.input-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.sub-type-input {
  width: 320px;
  height: 44px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #D0D5DD;
  background: #FFF;
  color: #344054;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease-in-out;
}
.sub-type-input:focus {
  border-color: #344054;
}
.button-container {
  margin-top: 0px;
  display: flex;
  justify-content: flex-start;
}
.service-provider-list {
  list-style: none;
  padding: 0;
  margin: 8px;
  max-height: 300px;
  overflow-y: auto;
  background: #FFF;
  color: #344054;
}
.service-provider-list li {
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid #D0D5DD;
  transition: background 0.2s ease-in-out;
}
.service-provider-list li:hover {
  background: #FFF1E0;
}
.validation-error {
  color: #d32f2f;
  font-size: 13px;
  margin-top: 4px;
}
/*# sourceMappingURL=formly-selector-type-MKA5JR7E.css.map */
